import { useState } from "react";

export const ProductWebsite = () => {
	const [loader, setLoader] = useState(true)
	const [websiteData, setWebsiteData] = useState({})
	const [hasWebsite, setHasWebsite] = useState(false)
	const [companyPromos, setCompanyPromos] = useState({promos: [], loader: false})
	const [search, setSearch] = useState('')
	const [inftScroll, setInftScroll] = useState(true)
	const [inftScrollLoader, setInftScrollLoader] = useState(true)
	const [lid, setLid] = useState('')
	const [viewPromo, setViewPromo] = useState({ data: {}, reviewCount: 0, reviews: [], loader: false })
	const [receipt, setReceipt] = useState(null)
	// FOR CART STATES
	const [cartLoaders, setCartLoaders] = useState({ readCart: false, itemId: '' })
	const [cartItems, setCartItems] = useState([])
	const [cartUpdate, setCartUpdate] = useState({ added: false, msg: "", removed: false })
	const [cartTotal, setCartTotal] = useState({ total: '', shippingFee: '' })
	const [ubrCart, setUbrCart] = useState([])
	// FOR CHECKOUT
	const [form, setForm] = useState({quantity: 1, last_name: '', first_name: '', contact_number:'', email: '', delivery_option: 'delivery', address: '', place_id: '', landmark: '', is_default: 0, date: '', time: '', remarks: '', pickup_time:'' , pickup_date:'', dragonpay: true,  sub_total: 0, total_amount: 0, shipping_fee: 0, shipping_id: '', payment_opt: 'full', payment_method: 'GCSH' })
	const [viewLoader, setViewLoader] = useState(true)
	const [promoPage, setPromoPage] = useState([])
	const [shippingRate, setShippingRate] = useState('')
	const [error, setError] = useState(false)
	const [confirmation, setConfirmation] = useState(false)
	const [btnLoader, setBtnLoader] = useState(false)
	const [discountList, setDiscountList] = useState([])
	const [deliveryAddresses, setDeliveryAddresses] = useState([]);
	const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
	const [toExpire, setToExpire] = useState('')
	const [showMyDiscount, setShowMyDiscount] = useState(false)
	// FOR MY ORDERS
	const [myOrders, setMyOrders] = useState({ type: 1, sub_type: 1 })
	const [myOrdersData, setMyOrdersData] = useState([])
	const [myOrdersLoader, setMyOrdersLoader] = useState(false)
	const [myOrdersView, setMyOrdersView] = useState({})
	const [myOrdersConfirmation, setMyOrdersConfirmation] = useState({ confirmId: '', loader: false, success: false, modal: false })
	// FOR MESSAGE
	const [messageForm, setMessageForm] = useState({ fullName: '', mobileNumber: '', email: '', message: '' })
	const [messageError, setMessageError] = useState(false)
	const [messageSubmit, setMessageSubmit] = useState({ modal: false, loader: false, success: false })
	const [messageAccModal, setMessageAccModal] = useState({modal: false, redirecting: false})
	// FOR REVIEWS
	const [review, setReview] = useState({ overall: 0, product_rate: 0, product_remarks: '', seller_rate: 0, seller_remarks: '', shipping_rate: 0, shipping_remarks: '', files: [], btnLoader: false, error: false, type: 'create', viewLoader: false, })
	const [fileMsg, setFileMsg] = useState('')
	const [viewImg, setViewImg] = useState({show: false, index: 0})
	// CHECK IF IT HAS ACC FOR MODAL PURPOSE
	const [accModal, setAccModal] = useState({modal: false, redirecting: false})

	return {
		loader: {data: loader, set: setLoader},
		websiteData: {data: websiteData, set: setWebsiteData},
		hasWebsite: {data: hasWebsite, set: setHasWebsite},
		companyPromos: {data: companyPromos, set: setCompanyPromos},
		search: {data: search, set: setSearch},
		inftScroll: {data: inftScroll, set: setInftScroll},
		inftScrollLoader: {data: inftScrollLoader, set: setInftScrollLoader},
		lid: {data: lid, set: setLid},
		viewPromo: {data: viewPromo, set: setViewPromo},
		receipt: {data: receipt, set: setReceipt},
		// FOR CART STATES
		cartLoaders: {data: cartLoaders, set: setCartLoaders},
		cartItems: {data: cartItems, set: setCartItems},
		cartUpdate: {data: cartUpdate, set: setCartUpdate},
		cartTotal: {data: cartTotal, set: setCartTotal},
		ubrCart: {data: ubrCart, set: setUbrCart},
		// FOR CHECKOUT
		form: {data: form, set: setForm},
		viewLoader: {data: viewLoader, set: setViewLoader},
		promoPage: {data: promoPage, set: setPromoPage},
		shippingRate: {data: shippingRate, set: setShippingRate},
		error: {data: error, set: setError},
		confirmation: {data: confirmation, set: setConfirmation},
		btnLoader: {data: btnLoader, set: setBtnLoader},
		discountList: {data: discountList, set: setDiscountList},
		deliveryAddresses: {data: deliveryAddresses, set: setDeliveryAddresses},
		selectedDeliveryAddress: {data: selectedDeliveryAddress, set: setSelectedDeliveryAddress},
		toExpire: {data: toExpire, set: setToExpire},
		showMyDiscount: {data: showMyDiscount, set: setShowMyDiscount},
		// FOR MY ORDERS
		myOrders: {data: myOrders, set: setMyOrders},
		myOrdersData: {data: myOrdersData, set: setMyOrdersData},
		myOrdersLoader: {data: myOrdersLoader, set: setMyOrdersLoader},
		myOrdersView: {data: myOrdersView, set: setMyOrdersView},
		myOrdersConfirmation: {data: myOrdersConfirmation, set: setMyOrdersConfirmation},
		// FOR MESSAGE
		messageForm: {data: messageForm, set: setMessageForm},
		messageError: {data: messageError, set: setMessageError},
		messageSubmit: {data: messageSubmit, set: setMessageSubmit},
		messageAccModal: {data: messageAccModal, set: setMessageAccModal},
		// FOR REVIEWS
		review: {data: review, set: setReview},
        fileMsg: {data: fileMsg, set: setFileMsg},
        viewImg: {data: viewImg, set: setViewImg},
		// CHECK IF IT HAS ACC FOR MODAL PURPOSE
		accModal: {data: accModal, set: setAccModal},
	}
}
